import { type FC } from 'react'
import { type RJSFSchema } from '@rjsf/utils'
import { ParametersRjsfForm } from './ParametersRjsfForm'

interface EffectiveParametersViewProps {
  schema: RJSFSchema
  parameters: Record<string, unknown>
}

export const EffectiveParametersView: FC<EffectiveParametersViewProps> = ({ schema, parameters }) => (
  <div className='d-flex flex-column zocks-gap-2'>
    <ParametersRjsfForm
      idPrefix='effective'
      schema={schema}
      formData={parameters}
      layer='user'
      defaultFormStateBehavior={{ emptyObjectFields: 'skipDefaults' }}
      readonly
    />
    <details>
      <summary className='paragraph-small zocks-text-gray-600'>Raw JSON</summary>
      <pre className='paragraph-small mb-0 overflow-x-auto'>{JSON.stringify(parameters, null, 2)}</pre>
    </details>
  </div>
)
